import { MenuItem, MenuList, Stack, Typography } from "@mui/material"
import { Dispatch, ReactElement, SetStateAction } from "react"

import { RELEASE_1_3_0 } from "./releases/1.3.0"
import { RELEASE_1_3_1 } from "./releases/1.3.1"
import { RELEASE_1_3_4 } from "./releases/1.3.4"
import { RELEASE_1_4_0 } from "./releases/1.4.0"
import { RELEASE_1_4_1 } from "./releases/1.4.1"
import { RELEASE_1_4_10 } from "./releases/1.4.10"
import { RELEASE_1_4_11 } from "./releases/1.4.11"
import { RELEASE_1_4_14 } from "./releases/1.4.14"
import { RELEASE_1_4_2 } from "./releases/1.4.2"
import { RELEASE_1_4_3 } from "./releases/1.4.3"
import { RELEASE_1_4_4 } from "./releases/1.4.4"
import { RELEASE_1_4_5 } from "./releases/1.4.5"
import { RELEASE_1_4_6 } from "./releases/1.4.6"
import { RELEASE_1_4_7 } from "./releases/1.4.7"
import { RELEASE_1_4_8 } from "./releases/1.4.8"
import { RELEASE_1_4_9 } from "./releases/1.4.9"
import { RELEASE_1_5_0 } from "./releases/1.5.0"
import { RELEASE_1_5_1 } from "./releases/1.5.1"
import { RELEASE_1_5_2 } from "./releases/1.5.2"
import { RELEASE_1_6_0 } from "./releases/1.6.0"
import { RELEASE_2_0_0 } from "./releases/2.0.0"
import { RELEASE_MIGRATION } from "./releases/migration"
import { IReleaseNote } from "./types"

interface IReleasePanelProps {
    selectedRelease: IReleaseNote
    setSelectedRelease: Dispatch<SetStateAction<IReleaseNote>>
}

const ReleasePanel = ({
    selectedRelease,
    setSelectedRelease,
}: IReleasePanelProps): ReactElement => (
    <Stack sx={{ minWidth: "175px" }}>
        <Typography variant="h6">Upcoming</Typography>
        <MenuList dense>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_MIGRATION}
                onClick={() => setSelectedRelease(RELEASE_MIGRATION)}
            >
                <Typography variant="body1" fontWeight={500}>
                    Migration Guide
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_2_0_0}
                onClick={() => setSelectedRelease(RELEASE_2_0_0)}
            >
                <Typography variant="body1" fontWeight={500}>
                    2.0.0
                </Typography>
            </MenuItem>
        </MenuList>
        <Typography variant="h6">Past</Typography>
        <MenuList dense>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_6_0}
                onClick={() => setSelectedRelease(RELEASE_1_6_0)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.6.0
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_5_2}
                onClick={() => setSelectedRelease(RELEASE_1_5_2)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.5.2
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_5_1}
                onClick={() => setSelectedRelease(RELEASE_1_5_1)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.5.1
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_5_0}
                onClick={() => setSelectedRelease(RELEASE_1_5_0)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.5.0
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_4_14}
                onClick={() => setSelectedRelease(RELEASE_1_4_14)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.4.14
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_4_11}
                onClick={() => setSelectedRelease(RELEASE_1_4_11)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.4.11
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_4_10}
                onClick={() => setSelectedRelease(RELEASE_1_4_10)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.4.10
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_4_9}
                onClick={() => setSelectedRelease(RELEASE_1_4_9)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.4.9
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_4_8}
                onClick={() => setSelectedRelease(RELEASE_1_4_8)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.4.8
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_4_7}
                onClick={() => setSelectedRelease(RELEASE_1_4_7)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.4.7
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_4_6}
                onClick={() => setSelectedRelease(RELEASE_1_4_6)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.4.6
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_4_5}
                onClick={() => setSelectedRelease(RELEASE_1_4_5)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.4.5
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_4_4}
                onClick={() => setSelectedRelease(RELEASE_1_4_4)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.4.4
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_4_3}
                onClick={() => setSelectedRelease(RELEASE_1_4_3)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.4.3
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_4_2}
                onClick={() => setSelectedRelease(RELEASE_1_4_2)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.4.2
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_4_1}
                onClick={() => setSelectedRelease(RELEASE_1_4_1)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.4.1
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_4_0}
                onClick={() => setSelectedRelease(RELEASE_1_4_0)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.4.0
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_3_4}
                onClick={() => setSelectedRelease(RELEASE_1_3_4)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.3.4
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_3_1}
                onClick={() => setSelectedRelease(RELEASE_1_3_1)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.3.1
                </Typography>
            </MenuItem>
            <MenuItem
                sx={{ borderRadius: 2 }}
                selected={selectedRelease === RELEASE_1_3_0}
                onClick={() => setSelectedRelease(RELEASE_1_3_0)}
            >
                <Typography variant="body1" fontWeight={500}>
                    1.3.0
                </Typography>
            </MenuItem>
        </MenuList>
    </Stack>
)

export default ReleasePanel
